document.addEventListener('DOMContentLoaded', () => {
  const triggers = document.querySelectorAll('[data-accordion-trigger]');
  const faqSections = document.querySelectorAll('.faqSection__Content');

  faqSections.forEach(section => {
    const firstFaqItem = section.querySelector('.faqBlock.accordionItem');
    const firstFaqContent = firstFaqItem?.querySelector('[data-accordion-content]');

    if (!firstFaqItem || !firstFaqContent || firstFaqItem.classList.contains('accordionItem--is-active')) return;

    firstFaqItem.classList.add('accordionItem--is-active');
    firstFaqContent.style.height = 'auto';
  });

  if (!triggers.length) return;

  triggers.forEach(trigger => {
    const item = trigger.closest('.accordionItem');
    const content = item?.querySelector('[data-accordion-content]');

    if (!item || !content) return;

    trigger.addEventListener('click', () => {
      const isOpen = item.classList.contains('accordionItem--is-active');

      // lock during animation
      content.classList.add('is-animating');

      if (isOpen) {
        // CLOSE
        content.style.height = content.scrollHeight + 'px'; // set current height
        requestAnimationFrame(() => {
          content.style.height = '0px';
        });
        item.classList.remove('accordionItem--is-active');
      } else {
        // OPEN
        item.classList.add('accordionItem--is-active');
        content.style.height = content.scrollHeight + 'px';
      }

      // cleanup after transition
      content.addEventListener(
        'transitionend',
        () => {
          content.classList.remove('is-animating');

          if (item.classList.contains('accordionItem--is-active')) {
            content.style.height = 'auto'; // allow responsive content
          }
        },
        { once: true }
      );
    });
  });

  const imageContainers = document.querySelectorAll('.accordionImage__MediaContainer');

  if (!imageContainers.length) return;

  imageContainers.forEach(container => {
    const images = container.querySelectorAll('.accordionImage__Media');

    if (images.length !== 2) return;

    images.forEach(image => {
      image.addEventListener('click', () => {
        const fullImage = container.querySelector('.accordionImage__Full');
        const thumbImage = container.querySelector('.accordionImage__Thumb');

        if (!fullImage || !thumbImage) return;

        // Swap classes
        fullImage.classList.remove('accordionImage__Full');
        fullImage.classList.add('accordionImage__Thumb');

        thumbImage.classList.remove('accordionImage__Thumb');
        thumbImage.classList.add('accordionImage__Full');
      });
    });
  });
});
